import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Player management was unified into /players.
// This route remains so any older deep-links keep working.
const Page = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/players', { replace: true });
  }, [navigate]);
  return null;
};

export default Page;
